'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRange = exports.hasNoModifier = exports.propOffset = undefined;

var _ramda = require('ramda');

var _breakpoints = require('../const/breakpoints');

var propOffset = exports.propOffset = (0, _ramda.prop)('offset');

// eslint-disable-next-line import/prefer-default-export
var hasNoModifier = exports.hasNoModifier = (0, _ramda.complement)((0, _ramda.has)('modifier'));

var isRange = exports.isRange = function isRange(value) {
  return (0, _ramda.indexOf)(_breakpoints.LT_MODIFIER, value) > 1;
};


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/range.js
// module id = 345
// module chunks = 168707334958949